export default function StreamInputDescInternalBus({ input }) {
  if (input.dangling) {
    return <>BUS DANGLING</>;
  } else {
    return <>BUS {input.stream_name}/{input.stream_output_name} →</>;
  }
}
